import { getCurrentDomainExtension } from './url.mjs';

let webToolsReadyPromise;

export function loadWebToolsModuleIfNeeded() {
  if (!webToolsReadyPromise) {
    webToolsReadyPromise = new Promise((resolve) => {
      const scriptTag = document.createElement('script');
      scriptTag.src = `https://wt.babbel.${getCurrentDomainExtension()}/wt/web-tools.cjs`;
      scriptTag.addEventListener('load', () => {
        globalThis.webTools.ready.then(resolve);
      });
      document.head.append(scriptTag);
    });
  }
  return webToolsReadyPromise;
}
